import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useInvCa, useInvMain } from "../../../../St/Reviews/UseStyle";

function FooterSand(props) {
  const clas = useInvCa();
  const clasm = useInvMain();
  const { found,onUnmountComplete } = props;

  const sty = {
    cntr: { textAlign: "center" },
    lft: { textAlign: "left", padingLeft: 5 },
    rit: { textAlign: "right", padingRight: 5 },
    dirR: { direction: "rtl", color: "black" },
    dirL: { direction: "ltr" },
  };

  return (
    <Grid item container style={sty.dirR}>
      <Grid item container style={sty.cntr} spacing={0}>
        <br />
        <Grid xs={12}>
          <Typography
            className={[clas.contntSub]}
            style={{
              margin: "0.8rem 0.1rem 0.2rem 0.1rem",
              borderRadius: 5,
              color: "#5e5e5e",
              background: "#ffffee",
              padding: "0.2rem 0.2rem 0.2rem 0.2rem",
            }}
          >
           <div style={{fontWeight:"bold",fontSize:"0.75rem",color:"black"}}>{found.Address}</div> 
          </Typography>
        </Grid>
        <br /> <br />
      </Grid>

      <Grid item container className={clas.Bdycntr}>
        <Grid item xs={4} className={clasm.minclr}>
          {"هاتف"}
        </Grid>
        <Grid item xs={4} className={clasm.minclr}>
          {"جوال"}
        </Grid>
        <Grid item xs={4} className={clasm.minclr}>
          {"فاكس"}
        </Grid>

        <Grid item xs={4} style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
          {found.Tel}
        </Grid>
        <Grid item xs={4} style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
          {found.Mobile}
        </Grid>
        <Grid item xs={4} style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
          {found.Fax}
        </Grid>
      </Grid>
    </Grid>
    // </span>
  );
}
export default FooterSand;
